var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H13V40H0V0ZM27 0H40V40H27V0Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 0H9V40H31V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9997 10L18.6024 13.0163C18.4439 13.3441 18.1598 13.3137 17.8757 13.1306L16.8641 12.5244L17.6181 17.1573C17.7766 18.0038 17.268 18.0038 17.0168 17.6378L15.2515 15.3503L14.9648 16.5119C14.9318 16.6645 14.7865 16.8247 14.5684 16.7866L12.336 16.2433L12.9224 18.7106C13.0479 19.2596 13.1458 19.4869 12.7957 19.6317L12 20.0646L15.8429 23.6774C15.995 23.814 16.0719 24.0599 16.0177 24.2824L15.6814 25.5599C17.0046 25.3834 18.1908 25.2254 19.514 25.0491C19.6316 25.0474 19.8265 25.163 19.8257 25.3198L19.6504 30H20.2937L20.1924 25.3298C20.1916 25.173 20.3684 25.0474 20.486 25.0491C21.8092 25.2254 22.9955 25.3834 24.3186 25.5599L23.9823 24.2824C23.9281 24.0599 24.005 23.814 24.1571 23.6774L28 20.0646L27.2043 19.6317C26.8542 19.4869 26.9521 19.2596 27.0776 18.7106L27.664 16.2433L25.4316 16.7866C25.2135 16.8247 25.0682 16.6645 25.0352 16.5119L24.7485 15.3503L22.9832 17.6378C22.732 18.0038 22.2234 18.0038 22.3819 17.1573L23.1359 12.5244L22.1243 13.1306C21.8402 13.3137 21.5561 13.3441 21.3976 13.0163",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCad);
export default __webpack_public_path__ + "static/media/cad.314be13c858009bff34683e6000faf0c.svg";
export { ForwardRef as ReactComponent };